import { getDeviceId } from 'Common/util/Net';

declare const APP_NAME: string;
declare const APP_ENV: string;
declare const SUMO_LOGIC_COMPASS_COLLECTION_URL: string;
declare const SUMO_LOGIC_DAZZLE_COLLECTION_URL: string;

export enum ULogApplication {
  DAZZLE = 1,
  COMPASS
}

export const getApp = () => {
  if (APP_NAME === 'dazzle') {
    return ULogApplication.DAZZLE;
  }
  return ULogApplication.COMPASS;
};

export enum ULogSeverity {
  INFO = 'INFO',
  DEBUG = 'DEBUG',
  WARN = 'WARN',
  ERROR = 'ERROR'
}

export enum ULogTag {
  Browser = 'Browser',
  General = 'General',
  PageView = 'PageView',
  UserInfo = 'UserInfo',
  UserAuth = 'UserAuth',
  UserAction = 'UserAction',
  Network = 'Network',
  UserError = 'UserError',
  Orders = 'Orders',
  Stripe = 'Stripe',
  Data = 'Data'
}

export const logSumoEvent = async (
  { app, severity, userId = 'unauthenticated', tag = ULogTag.General, message }: {
    app: ULogApplication,
    severity: ULogSeverity,
    userId?: string,
    tag: ULogTag,
    message: string
  }
) => {
  let endpoint: string | undefined;
  if (app === ULogApplication.COMPASS) {
    endpoint = SUMO_LOGIC_COMPASS_COLLECTION_URL;
  } else if (app === ULogApplication.DAZZLE) {
    endpoint = SUMO_LOGIC_DAZZLE_COLLECTION_URL;
  }

  if (endpoint === undefined) {
    // console.log(`${severity} : ${tag} : ${userId} : ${message}`)
    return;
  }

  const timestamp = Date.now();
  const deviceId = getDeviceId();

  // timestamp
  // thread (main, background)
  // severity
  // device ID (n/a for web)
  // app distribution/environment
  // Sunshine UUID | "unauthenticated"
  // Tag
  const body = `${timestamp} | main | ${severity} | ${deviceId} | ${navigator.userAgent} | ${APP_ENV} | ${userId} | ${tag} | ${document.location.pathname}${document.location.search} | ${message}`;

  try {
    await fetch(endpoint, {
      method: 'POST',
      mode: 'no-cors',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'text/plain'
      },
      referrerPolicy: 'no-referrer',
      body,
    });
  } catch (e) {

    console.log(`[SumoLogicApi] Error while logging to Sumo Logic: ${stringifyError(e)}`);
  }
};

export const stringifyError = (e: Error): string => {
  return JSON.stringify(e, [...(Array.from(Object.keys(e))), 'message', 'arguments', 'type', 'name']);
};
